import Mail from "./Mail";

export default Mail


// WEBPACK FOOTER //
// /src/components/mailThread/mail/index.js